import http from '@/utils/http'
export function getIndexDetail() {
    return http.get('/pm/server-pm/project/getDetail')
}
// 查询部门列表无权限
export function listFeign(query) {
    return http.get('/system/dept/deptList', query)
}

// 查询销售统计表
export function checkTable(data) {
    return http.get('/pm/server-pm/projectVo/listByDate', data)
}

// 查询销售项目信息详细
export function getProject(id) {
    return http.get('/pm/server-pm/project/' + id)
}
// 查询研发统计表
export function checkResearchTable(data) {
    return http.get('/pm/server-pm/research/projectVo/listByDate', data)
}

// 查询研发项目信息详细
export function getResearchProject(id) {
    return http.get('/pm/server-pm/research/project/' + id)
}

// 查询项目周报列表
export function listWeekly(query) {
    return http.get('/pm/server-pm/weekly/list', query)
}
// 查询项目周报列表
export function listWeeklyResearch(query) {
    return http.get('/pm/server-pm/weeklyResearch/list', query)
}